module.exports = __webpack_public_path__ + "img/iphonex.36e683a6.jpg";